/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { run  } from './Mission';

run(document.getElementById('viewer'), './resources/earth_decimated.obj', false);
